<template>
    <OverlayLoader :isLoading="!resellerLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('resellers.summary')"
                />

                <p>{{ t('resellers.summary.text') }}</p>

                <Alert :show="!reseller.setup_completed">{{ t('resellers.summary.setup_completed') }}</Alert>

                <Alert :show="reseller.has_minox_exception" type="danger" style="display: flex; flex-direction: column;">
                    <p class="alert-title">We receivid an error message from our accounting software</p>
                    <span style="margin-top: 2px;">{{ reseller.minox_exception_message}} Please double-check the information you entered and try again.</span>
                </Alert>

                <form @submit.prevent="submitForm" method="POST">
                    <h4>{{ t('resellers.summary.reseller') }}</h4>

                    <TextInput
                        id="companyName"
                        :value="reseller.company_name"
                        name="companyName"
                        @change="reseller.company_name = $event"
                        :label="$translate.text('general.company.name')"
                        required
                    />

                    <TextInput
                        id="street"
                        :value="reseller.street"
                        name="street"
                        @change="reseller.street = $event"
                        :label="$translate.text('general.address.street')"
                        required
                    />

                    <TextInput
                        id="zipcode"
                        :value="reseller.zipcode"
                        name="zipcode"
                        @change="reseller.zipcode = $event"
                        :label="$translate.text('general.address.zipcode')"
                        required
                    />

                    <TextInput
                        id="city"
                        :value="reseller.city"
                        name="city"
                        @change="reseller.city = $event"
                        :label="$translate.text('general.address.city')"
                        required
                    />

                    <Select
                        v-if='countriesLoaded'
                        id="country_id"
                        :value="reseller.country_id"
                        name="type"
                        @change="reseller.country_id = parseInt($event, 0)"
                        :options="countriesSelectValues"
                        :label="$translate.text('general.address.country')"
                    />

                    <Select
                        v-if='countriesLoaded && reseller.country_id != null'
                        id="state_id"
                        :value="reseller.state_id"
                        name="state_id"
                        @change="reseller.state_id = parseInt($event, 0)"
                        :options="statesSelectValues"
                        :label="$translate.text('general.address.state')"
                    />

                    <h4>{{ t('resellers.summary.contact_information') }}</h4>

                    <TextInput
                        id="contactName"
                        :value="reseller.contact_name"
                        name="contactName"
                        @change="reseller.contact_name = $event"
                        :label="$translate.text('general.contact.name')"
                    />

                    <TextInput
                        id="phone"
                        :value="reseller.phone"
                        name="phone"
                        @change="reseller.phone = $event"
                        :label="$translate.text('general.contact.phone')"
                    />

                    <EmailInput
                        id="email"
                        :value="reseller.email"
                        name="email"
                        @change="reseller.email = $event"
                        :label="$translate.text('general.contact.email')"
                        required
                    />

                    <TextInput
                        id="website"
                        :value="reseller.website"
                        name="website"
                        @change="reseller.website = $event"
                        :label="$translate.text('general.company.website')"
                    />

                    <UploadInput
                        id="fileUpload"
                        :value="reseller.original_logo_name"
                        name="fileUpload"
                        @change="reseller.logo = $event"
                        :uploadPercentage ="uploadPercentage"
                        :label="$translate.text('general.company.logo')"
                    />

                    <!-- Removed because its going to be in the account settings.  -->
                    <!-- <Select
                        id="language"
                        :value="reseller.language"
                        name="language"
                        @change="reseller.language = $event"
                        :options="languageOptions"
                        :label="$translate.text('locales.preferred_language')"
                    /> -->

                    <h4>{{ t('general.extra_information') }}</h4>

                    <TextInput
                        id="iban"
                        :value="reseller.iban"
                        name="iban"
                        @change="reseller.iban = $event"
                        :label="$translate.text('general.company.iban')"
                        required
                    />

                    <TextInput
                        id="kvk"
                        :value="reseller.kvk"
                        name="kvk"
                        @change="reseller.kvk = $event"
                        :label="$translate.text('general.company.chamber_of_commerce')"
                        required
                    />

                    <TextInput
                        id="btw"
                        :value="reseller.btw"
                        name="btw"
                        @change="reseller.btw = $event"
                        :label="$translate.text('general.company.vat_number')"
                        required
                    />

                    <FormSubmit
                        :buttonLabel="submittingIsLoading ? $translate.text('general.save_changes.saving') :  $translate.text('general.save_changes')"
                        :disabled="submittingIsLoading"
                    />
                </form>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import axios from 'axios';

import Alert from '@/components/Alert/Alert';
import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import EmailInput from '@/components/Inputs/EmailInput';
// import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import UploadInput from '@/components/Inputs/UploadInput';

import { get } from '@/helpers/http';
import { getUser, getHeaders, getToken } from '@/helpers/auth';
import handleError from '@/helpers/error';
import Select from '@/components/Inputs/Select';


export default {
    name: 'Summary',

    components: {
        Select,
        Alert,
        PageHeader,
        TextInput,
        EmailInput,
        FormSubmit,
        // Select,
        OverlayLoader,
        UploadInput,
    },

    data() {
        return {
            reseller: {
                logo: {
                    name: '',
                },
                country_id: null,
                state_id: null,
            },
            resellerLoaded: false,

            // languageOptions: [
            //     { label: this.$translate.text('locales.dutch'), value: 'nl_NL' },
            //     { label: this.$translate.text('locales.english'), value: 'en_EN' },
            //     { label: this.$translate.text('locales.german'), value: 'de_DE' },
            // ],

            countries: [],
            countriesLoaded: false,

            submittingIsLoading: false,

            uploadPercentage: 0,
        };
    },

    created() {
        this.getReseller();
        this.getCountries();
    },

    methods: {
        getReseller() {
            const resellerId = getUser().reseller.id;

            get({
                url: `${this.$API_URL}/api/resellers/reseller/${resellerId}`,
            })
                .then((response) => {
                    // if (response.data.data.logo === '' || response.data.data.logo === null) {
                    //     response.data.data.logo.name = '';
                    // }
                    this.reseller = response.data.data;
                    this.resellerLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCountries() {
            get({
                url: `${this.$API_URL}/api/countries`,
            })
                .then((response) => {
                    this.countries = response.data.data;

                    this.countriesLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            // get the headers
            const headers = getHeaders(getToken());
            headers['Content-Type'] = 'multipart/form-data';

            this.submittingIsLoading = true;

            this.reseller.phone = this.reseller.phone === null ? null : this.reseller.phone.toString();

            const data = this.reseller;
            const formdata = new FormData();
            Object.keys(data).forEach(key => {
                if (data[key] !== '' && data[key] !== null) {
                    formdata.append(key, data[key]);
                }
            });


            axios({
                method: 'POST',
                url: `${this.$API_URL}/api/resellers/reseller/${this.reseller.id}`,
                headers,
                data: formdata,

                // eslint-disable-next-line
                onUploadProgress: function (progressEvent) {
                    // eslint-disable-next-line
                    this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                }.bind(this),
            })
                .then(async () => {
                    /*
                        First we call the getUser call, which will update
                        the user in the localStorage. After that, we'll
                        get the reseller again to update the setup_completed field
                    */
                    await this.$http.getUser();
                    this.getReseller();
                    this.submittingIsLoading = false;

                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.success.message.saved'),
                    });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });

                    this.submittingIsLoading = false;
                });
        },
    },

    computed: {
        countriesSelectValues() {
            const values = [{ label: this.$translate.text('general.select_option'), value: null, disabled: true }];

            this.countries.forEach(country => {
                values.push({
                    value: parseInt(country.id, 0),
                    label: country.name,
                });
            });

            return values;
        },

        statesSelectValues() {
            const values = [{ label: this.$translate.text('general.select_option'), value: null, disabled: true }];

            this.countries.forEach(country => {
                if (country.id === parseInt(this.reseller.country_id, 0)) {
                    country.states.forEach(state => {
                        values.push({
                            value: parseInt(state.id, 0),
                            label: state.name,
                        });
                    });
                }
            });

            return values;
        },
    },
};
</script>
<style lang="scss" scoped>
.alert {
    margin-bottom: 0;
}

form {
    padding-top: 24px;
}
</style>
